import { getIBBroadcasts } from '@/api/ibModule';

export default {
  namespaced: true,

  state: () => ({
    sent: [],
    loaded: false,
  }),

  getters: {
    sentBroadcasts: (state) => state.sent,
  },

  mutations: {
    setBroadcasts(state, broadcasts) {
      state.sent = broadcasts;
      state.loaded = true;
    },

    prependBroadcast(state, broadcast) {
      state.sent = [broadcast, ...state.sent];
    },
  },

  actions: {
    async fetchBroadcasts({ commit }) {
      const { broadcasts } = await getIBBroadcasts();
      commit('setBroadcasts', broadcasts || []);
    },
  },
};
